import { createHttpServiceConfig } from '@/services/httpFactories';
import { INTERPRETER_SERVICE_ENDPOINT, FILE_UPLOAD_RESOURCE_PATH } from './interpreterServiceConstants';

const interpreterModelServiceConfig = {
    ...createHttpServiceConfig(INTERPRETER_SERVICE_ENDPOINT, FILE_UPLOAD_RESOURCE_PATH)
};

/**
 * @param {FormData} data
 * @param {import('./interpreterServiceTypes').IFileUploadParams} params
 */
export const uploadFileService = (data, params) => interpreterModelServiceConfig.http({
    method: 'POST',
    headers: {'Content-Type': 'multipart/form-data'},
    params,
    data
});

/**
 * @param {string} moduleId
 * @param {string} fieldId
 * @param {string} sessionId 
 */
export const deleteUploadedFileService = (moduleId, fieldId, sessionId) => interpreterModelServiceConfig.http({
    method: 'DELETE',
    url: `${moduleId}/${fieldId}/${sessionId}`
});
